<template>
  <div class="exp-box approved_box">
    <ax-result-page
      v-if="showResult"
      type="network"
      subtext="要不然下拉刷新试试？"
    ></ax-result-page>
    <div v-if="!showResult && showContent">
      <div class="number already-number">单号：{{ data.expReportNumber }}</div>
      <ax-panel title="团建信息" v-if="data.documentTypeCode === '300'">
        <van-cell title="开始日期" v-model="data.activityStartDate"></van-cell>
        <van-cell title="结束日期" v-model="data.activityEndDate"></van-cell>
        <van-cell title="团建费地点" v-model="data.activityPlace"></van-cell>
        <van-cell title="占用工作小时" v-model="data.holdingTime"></van-cell>
        <van-cell title="所在办公地" v-model="data.activityOffice"></van-cell>
        <van-cell title="是否为办公市区" v-model="data.isDowntown"></van-cell>
        <!-- <van-cell title="流程及内容" v-model="data.description"></van-cell> -->
      </ax-panel>
      <ax-panel title="备注" v-if="data.description" >
          <div class="remark" >
            <span class="text-block">{{ data.description.slice(0, 100) }}</span>
            <span v-if="data.description.length > 100">...</span>
            <span
              v-if="data.description.length > 100"
              class="view-more"
              @click="viewMore"
              >查看更多</span
            >
          </div>
      </ax-panel>
      <!-- :title="item.travelDesc" -->
      <div v-if="data.documentTypeCode === '200'">
        <ax-exp-panel
          class="exp-panel"
          v-for="(item, index) in data.reportTravelList"
          :key="index"
          :noTitle="true"
         
        >
          <travel-cell>
            <template slot="type"
              ><svg-icon :icon-class="transportation[item.mediaName]"
            /></template>
            <template slot="add"
              >{{ item.fromAdd }}-{{ item.toAdd }}</template
            >
            <template slot="money"
              >{{ item.currencySymbol
              }}{{ item.travelAmount | money }}</template
            >
            <template slot="date"
              >{{ item.dateFrom }}至{{ item.dateTo }}（{{
                item.travelDays
              }}天）</template
            >
          </travel-cell>
          <van-cell
            title="随行人"
            v-if="item.membersName && item.membersName !== ''"
            >{{ item.membersName }}</van-cell
          >
          <ax-panel class="exp-panel" title="费用明细">
            <div
              v-for="(vItem, vIndex) in data.reportLinesVlList"
              :key="vIndex"
              v-if="vItem.expTravelLinesId === item.expTravelLinesId"
            >
              <van-cell
                class="right-cell"
                :class="{ 'top-item': vIndex !== 0 }"
              >
                <template slot="title">
                  <span class="custom-title">{{ vItem.expenseItem }}</span>
                  <span class="data">{{ vItem.periodName }}</span>
                  <div class="intro">
                    <span v-if="vItem.lineDesc && vItem.lineDesc !== ''">{{
                      vItem.lineDesc
                    }}</span>
                    <span v-else>{{ vItem.expenseItem }}</span>
                  </div>
                </template>
                <div class="mark-item timer-con">
                  <span>
                    {{ vItem.currencySymbol }}{{ vItem.lineAmount | money }}
                  </span>
                  <span
                    class="modified"
                    v-if="vItem.amtUpdateCount == 1"
                    @click="handleModified(vItem)"
                    >已修改</span
                  >
                </div>
              </van-cell>
              <ax-down
                class="out-down"
                v-for="(fileItem, index) in vItem.reportAtmList"
                type="exp"
                :data="fileItem"
                :key="index"
              ></ax-down>
            </div>
            <!-- 明细行展示差旅 -->
            <div v-if="isViewmoreDetail">
              <div
                v-for="(vItem, vIndex) in reportLinesVlListAll"
                :key="vIndex"
                v-if="vItem.exp_travel_lines_id == item.expTravelLinesId"
              >
                <van-cell
                  class="right-cell"
                  :class="{ 'top-item': vIndex !== 0 }"
                >
                  <template slot="title">
                    <span class="custom-title">{{ vItem.expense_item }}</span>
                    <span class="data">{{ vItem.period_name }}</span>
                    <div class="intro">
                      <span v-if="vItem.line_desc && vItem.line_desc !== ''">{{
                        vItem.line_desc
                      }}</span>
                      <span v-else>{{ vItem.expense_item }}</span>
                    </div>
                  </template>
                  <div class="mark-item timer-con">
                    {{ vItem.currency_symbol }}{{ vItem.line_amount | money }}
                    <span
                      class="modified"
                      v-if="vItem.amt_update_aount == 1"
                      @click="handleModified(vItem)"
                      >已修改</span
                    >
                  </div>
                </van-cell>
                <ax-down
                  class="out-down"
                  v-for="(fileItem, index) in vItem.report_atm_list"
                  type="exp"
                  :data="fileItem"
                  :key="index"
                ></ax-down>
              </div>
            </div>
            <!-- lineNumber 大于3展示。  v-if="data.lineNumber > 3"-->
            <template v-if="data.lineNumber > 3">
              <!-- 全部明细 头-->
              <div class="fullDetailTitle" @click="viewmoreDetail">
                <span style="margin-right: 5px;">{{ viewmoreDetailText }}</span>
                <!-- 打开 -->
                <van-icon name="arrow-down" v-show="!isViewmoreDetail" />
                <!-- 收起 -->
                <van-icon name="arrow-up" v-show="isViewmoreDetail" />
              </div>
            </template>
          </ax-panel>
        </ax-exp-panel>
      </div>
      <div v-else>
        <ax-panel title="费用明细">
          <div v-for="(vItem, vIndex) in data.reportLinesVlList" :key="vIndex">
            <van-cell class="right-cell" :class="{ 'top-item': vIndex !== 0 }">
              <template slot="title">
                <span class="custom-title">{{ vItem.expenseItem }}</span>
                <span class="data">{{ vItem.periodName }}</span>
                <div class="intro">
                  <span v-if="vItem.lineDesc && vItem.lineDesc !== ''"
                    ><b class="data" v-if="vItem.expenseItem === '交通费-加班'"
                      >可打车{{ vItem.attendDates }}次</b
                    >{{ vItem.lineDesc }}</span
                  >
                  <span v-else
                    ><b class="data" v-if="vItem.expenseItem === '交通费-加班'"
                      >可打车{{ vItem.attendDates }}次</b
                    >{{ vItem.expenseItem }}</span
                  >
                </div>
              </template>
              <div class="mark-item timer-con">
                <span
                  >{{ vItem.currencySymbol
                  }}{{ vItem.lineAmount | money }}</span
                >
                <span
                  class="modified"
                  v-if="vItem.amtUpdateCount == 1"
                  @click="handleModified(vItem)"
                  >已修改</span
                >
              </div>
            </van-cell>
            <div v-if="data.documentTypeCode === '300'">
              <van-cell
                title="参与人数"
                :value="vItem.participantsNumber"
              ></van-cell>
              <van-cell title="人均">
                <span class="mark-item"
                  >{{ vItem.currencySymbol }}{{ vItem.perAmount | money }}</span
                >
              </van-cell>
            </div>
            <ax-down
              class="out-down"
              v-for="(fileItem, index) in vItem.reportAtmList"
              type="exp"
              :data="fileItem"
              :key="index"
            ></ax-down>
          </div>
          <!-- 明细行展示 -->
          <div v-if="isViewmoreDetail">
            <div v-for="(vItem, vIndex) in reportLinesVlListAll" :key="vIndex">
              <van-cell
                class="right-cell"
                :class="{ 'top-item': vIndex !== 0 }"
              >
                <template slot="title">
                  <span class="custom-title">{{ vItem.expense_item }}</span>
                  <span class="data">{{ vItem.period_name }}</span>
                  <div class="intro">
                    <span v-if="vItem.line_desc && vItem.line_desc !== ''"
                      ><b
                        class="data"
                        v-if="vItem.expense_item === '交通费-加班'"
                        >可打车{{ vItem.attendDates }}次</b
                      >{{ vItem.line_desc }}</span
                    >
                    <span v-else
                      ><b
                        class="data"
                        v-if="vItem.expense_item === '交通费-加班'"
                        >可打车{{ vItem.attendDates }}次</b
                      >{{ vItem.expense_item }}</span
                    >
                  </div>
                </template>
                <div class="mark-item timer-con">
                  <span
                    >{{ vItem.currency_symbol
                    }}{{ vItem.line_amount | money }}</span
                  ><span
                    class="modified"
                    v-if="vItem.amt_update_aount == 1"
                    @click="handleModified(vItem)"
                    >已修改</span
                  >
                </div>
              </van-cell>
              <div v-if="data.documentTypeCode === '300'">
                <van-cell
                  title="参与人数"
                  :value="vItem.participantsNumber"
                ></van-cell>
                <van-cell title="人均">
                  <span class="mark-item"
                    >{{ vItem.currency_symbol
                    }}{{ vItem.per_amount | money }}</span
                  >
                </van-cell>
              </div>
              <ax-down
                class="out-down"
                v-for="(fileItem, index) in vItem.report_atmList"
                type="exp"
                :data="fileItem"
                :key="index"
              ></ax-down>
            </div>
          </div>
          <!-- lineNumber 大于3展示。  v-if="data.lineNumber > 3"-->
          <template v-if="data.lineNumber > 3">
            <!-- 全部明细 头-->
            <div class="fullDetailTitle" @click="viewmoreDetail">
              <span style="margin-right: 5px;">{{ viewmoreDetailText }}</span>
              <!-- 打开 -->
              <van-icon name="arrow-down" v-show="!isViewmoreDetail" />
              <!-- 收起 -->
              <van-icon name="arrow-up" v-show="isViewmoreDetail" />
            </div>
          </template>
        </ax-panel>
      </div>
      <itinerary-details
        v-if="data.tripItineraryLines && data.tripItineraryLines.length > 0"
        :tripItineraryLines="data.tripItineraryLines"
      />
      <ax-panel title="报销表单信息">
        <van-cell title="单据类型" v-model="data.documentType"></van-cell>
        <van-cell title="单据单号" v-model="data.expReportNumber"></van-cell>
        <van-cell title="单据日期" v-model="data.reportDate"></van-cell>
        <van-cell class="des-cell" title="报销金额">
          {{ data.currencySymbol }}{{ data.documentAmount | money }}
        </van-cell>
        <van-cell class="des-cell" title="注意事项" v-if="data.attentionDesc">
          {{ data.attentionDesc }}
        </van-cell>
      </ax-panel>
      <ax-panel title="申请人信息">
        <van-cell title="姓名" :value="data.employeeName"></van-cell>
        <van-cell title="域账号">
          <a
            class="mail_a"
            :href="'mailto:' + data.employeeDomain + '@360.cn'"
            >{{ data.employeeDomain }}</a
          >
        </van-cell>
        <van-cell title="电话" v-if="data.employeeMobil">
          <a class="link_a" :href="'tel:' + data.employeeMobil">{{
            data.employeeMobil
          }}</a>
        </van-cell>
        <van-cell title="部门" :value="data.employeeUnit"></van-cell>
      </ax-panel>
      <suspend-button v-if="ownApprovalFlag" @click="recordJump"
        >审批<br />记录</suspend-button
      >
      <van-popup
        v-model="isDescription"
        position="top"
        :style="{ 'max-height': '30%' }"
      >
        <div class="remark">{{ data.description }}</div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { fetchData, getCuxhecexplinesinfo } from "@/api/exp";
import TravelCell from "@/components/common/TravelCell.vue";
import ItineraryDetails from "./ItineraryDetails.vue";
import { isOwnApprovalBySource } from "@/utils/util";
export default {
  name: "expEndDetails",
  components: {
    "travel-cell": TravelCell,
    "itinerary-details": ItineraryDetails,
  },
  data() {
    return {
      headerId: this.$route.query.headerId,
      apply: this.$route.query.apply || false,
      data: {},
      opinion: "",
      subDetails: [],
      showResult: false,
      showContent: false,
      isDescription: false,
      transportation: {
        飞机: "aircraft",
        高铁: "train",
        动车: "train",
        火车: "train",
        大巴: "bus",
        undefined: "other",
        其他: "other",
      },
      isViewmoreDetail: false,
      reportLinesVlListAll: [],
      reportLinesVlListAllCopy: [],
      viewmoreDetailText: "查看更多",
      action: "1",
      toast: null,
    };
  },
  computed: {
    ownApprovalFlag() {
      return isOwnApprovalBySource(this.$route.query.source);
    },
  },
  created() {
    this.getDetailsData();
  },
  methods: {
    getDetailsData() {
      this.toast = this.$toast.loading({
        mask: false,
        message: "加载中...",
        duration: 0,
      });
      fetchData("getExpDetails", {
        "Q-CA-ApiKey": "a3abc67b-850d-4eef-a81f-bed0a0d5cfda",
        report_header_id: this.headerId,
        currentDomainName: "zhaodan-it",
      })
        .then((response) => {
          this.toast.clear();
          if (response.data.success === true) {
            this.data = response.data.data;
            this.data.tripItineraryLines = this.data.tripItineraryLines
              ? this.data.tripItineraryLines.filter(
                  (item) => !item.travelCancel
                )
              : [];
            this.$setIosTitle(this.data.documentType);
            this.showContent = true;
          } else {
            this.showResult = true;
          }
        })
        .catch(() => {
          this.toast.clear();
          this.showResult = true;
        });
    },
    viewmoreDetail() {
      this.isViewmoreDetail = !this.isViewmoreDetail;
      this.viewmoreDetailText = this.isViewmoreDetail ? "收起" : "查看更多";
      // 如果当前被选择了，且reportLinesVlListAll的数据为空，那就去请求数据，否则使用原来的数据
      if (
        this.isViewmoreDetail &&
        this.reportLinesVlListAll &&
        this.reportLinesVlListAll.length === 0
      ) {
        this.toast = this.$toast.loading({
          mask: false,
          message: "加载中...",
          duration: 0,
        });
        getCuxhecexplinesinfo({
          report_header_id: this.headerId,
          "Q-CA-ApiKey": "14636508-d4bc-48bf-bd3e-95bc3221e72b",
        })
          .then((response) => {
            this.toast.clear();
            if (response.data.success === true) {
              const transData = response.data.data;
              // 数据前3个不展示
              this.reportLinesVlListAll = transData.slice(3);
              this.reportLinesVlListAllCopy = transData.slice(3);
            } else {
              this.$toast.fail(response.data.message);
            }
          })
          .catch(() => {
            this.toast.clear();
            this.$toast.fail("请稍后重试！");
          });
      } else {
        this.reportLinesVlListAll = this.reportLinesVlListAllCopy;
      }
    },
    // 跳转到修改页面
    handleModified(value) {
      console.log(value, "value");
      this.$router.push({
        path: "/exp/invoiceDetails",
        query: {
          expReportLineId: value.expReportLineId,
        },
      });
    },
    viewMore() {
      this.isDescription = true;
    },
    // 跳转到审批记录
    recordJump() {
      this.$router.push({
        path: "/exp/record",
        query: {
          headerId: this.headerId,
        },
      });
    },
  },
  beforeDestroy() {
    this.toast.clear();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/exp.scss";
</style>
